const formLabelModalSupportFiles = {
  label: 'Visibilidad'
};

export default formLabelModalSupportFiles;
